import React, { useState } from 'react';
import { TrashCanOutlined } from '@duxton-web/icons';
import { Button, Modal, ModalProps, Tooltip } from '@duxton-web/ui';
import { useParams } from 'react-router-dom';

import { isCreateMode } from '../../constants';
import {
  useExperimentContext,
  useExperimentDispatchContext,
} from '../../contexts/experiment-context';
import { deleteConfiguration } from '../../store/actions/experiment/action-creators';

const DeleteConfigurationModal = ({
  open,
  onCancel,
  onOk,
  index,
}: ModalProps & { index: number }) => {
  if (!open) return null;

  const experimentDispatch = useExperimentDispatchContext();

  return (
    <Modal
      centered
      width={700}
      maskClosable={false}
      okButtonProps={{
        size: 'small',
        danger: true,
      }}
      cancelButtonProps={{
        size: 'small',
      }}
      title="Delete Configuration"
      open={open}
      onCancel={onCancel}
      onOk={(e) => {
        experimentDispatch(deleteConfiguration(index));

        onOk(e);
      }}
      okText="Delete Configuration"
    >
      Are you sure you want to delete this configuration?
    </Modal>
  );
};

const DeleteConfiguration = ({
  index,
  style,
}: {
  index: number;
  style?: React.CSSProperties;
}) => {
  const params = useParams<{ action: string }>();
  const action = params.action;

  const experimentContext = useExperimentContext();
  const { configurations } = experimentContext;

  const [open, setOpen] = useState(false);

  if (configurations.length < 2 || !isCreateMode(action)) return null;

  return (
    <>
      <Tooltip title="Click here to delete configuration">
        <Button
          style={style}
          type="secondary"
          shape="circle"
          size="small"
          icon={<TrashCanOutlined />}
          onClick={() => setOpen(true)}
        />
      </Tooltip>

      <DeleteConfigurationModal
        index={index}
        open={open}
        onCancel={() => setOpen(false)}
        onOk={() => setOpen(false)}
      />
    </>
  );
};

export default DeleteConfiguration;
